import { normalizeMuscleGroups } from '@/features/workouts/api/muscleGroups'
import type { Exercise } from '@/types'

export function getSharedMuscleGroups(source?: string[], candidate?: string[]) {
  const sourceGroups = normalizeMuscleGroups(source)
  const candidateGroups = new Set(normalizeMuscleGroups(candidate))

  return sourceGroups.filter((group) => candidateGroups.has(group))
}

export function rankSwapExercises(options: {
  currentExerciseId: string
  trainerId: string
  targetMuscleGroups?: string[]
  exercises: Exercise[]
}) {
  const { currentExerciseId, trainerId, targetMuscleGroups, exercises } = options

  return exercises
    .filter((exercise) => exercise.id !== currentExerciseId)
    .map((exercise) => ({
      exercise,
      sharedGroups: getSharedMuscleGroups(targetMuscleGroups, exercise.targetMuscleGroups),
    }))
    .filter((entry) => entry.sharedGroups.length > 0)
    .sort((a, b) => {
      if (b.sharedGroups.length !== a.sharedGroups.length) {
        return b.sharedGroups.length - a.sharedGroups.length
      }

      if (a.exercise.trainerId !== b.exercise.trainerId) {
        return a.exercise.trainerId === trainerId ? -1 : 1
      }

      return a.exercise.name.localeCompare(b.exercise.name)
    })
}
